<template>
  <div class="audio_detail_container">
    <div class="audio_box">
      <div class="player_box" v-if="!!audioInfo && audioInfo.audioList">
        <div class="player_box_bg">
          <img :src="audioInfo.imgUrl" alt="">
        </div>
        <video controls controlslist="nodownload" disablepictureinpicture :src="audioInfo.audioList[0].playUrls[0].playUrl"  v-if="audioInfo.audioList.length>0"></video>
      </div>
      <div class="detail_box" ref="detailBox">
        <!-- 详情 -->
        <div class="detail_info" v-if="!!audioInfo" ref="audioInfoBox">
          <div class="title" v-text="audioInfo.title"></div>
          <div class="detail_text">
            <span class="source" v-text="!!audioInfo.source && audioInfo.source != ''? audioInfo.source: appName"></span>
            <span class="time" v-text="audioInfo.publishTime"></span>
          </div>
          <div class="detail_cont" v-html="audioInfo.summary"></div>
        </div>
        <!-- 相关音频 -->
        <related-audio :list="audioInfo.relatedList" v-if="!!audioInfo && audioInfo.relatedList && audioInfo.relatedList.length > 0"></related-audio>
        <!-- 评论 -->
        <div ref="comment">
          <comment :params="commentParams" @replyForm="showCommentReplayForm" v-if="!!audioInfo"></comment>
        </div>
      </div>
    </div>
    <!-- 底部操作 -->
    <operate :params="detailParams" :id="audioInfo.id" :contentId="audioInfo.contentId" :contentTitle="audioInfo.title" :isCollect="audioInfo.isCollect" :likeType="audioInfo.likeType" :allowLikes="audioInfo.likesSupport" :allow="audioInfo.allowComment" v-if="!!audioInfo" @isToComment="isToComment" @showCommentForm="showCommentForm"></operate>
    <!-- 发布评论 -->
    <submit-comment v-if="!!audioInfo" :show="isShowCommentForm" :id="audioInfo.id" :type="audioInfo.contentType" :parentId="commentParentId" :title="audioInfo.title" @showCommentForm="showCommentForm"></submit-comment>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, clickPlayCount, addScore } from "@/utils";
import audioApi from "@/api/apis/audio.js";
import { trackArticleDetailPg } from "@/utils/qt.js";
import commApi from "@/api/apis/common.js";
import RelatedAudio from "./components/RelatedAudio"; // 相关音频
import comment from "./components/Comment"; // 评论
import operate from "./components/Operate"; // 底部
import submitComment from "./components/SubmitComment"; // 发表评论
export default {
  name: "AudioDetail",
  data() {
    return {
      /* 是否显示评论表单 */
      isShowCommentForm: false,
      commentParentId: "0",
      /* 获取详情所需的参数 */
      detailParams: {
        contentType: null,
        contentId: null,
        fromFlag: null,
        cId: null,
      },
      /* 获取评论列表的参数 */
      commentParams: {
        contentId: null,
        type: null,
      },
      audioInfo: null, // 音频详情
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "appName"]),
  },
  components: {
    RelatedAudio,
    comment,
    operate,
    submitComment,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/audio_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.audioInfo.title + " - 法治号客户端", _this.audioInfo.introduction, _this.shareUrl, _this.audioInfo.sharePictureUrl);
      }).catch((err) => {

      });
    },
    /* 获取音频详情 */
    getAudioDetail() {
      var _this = this;
      audioApi
        .getAudioDetailById(_this.detailParams)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.title;
            _this.audioInfo = res.data;
            _this.commentParams.contentId = _this.audioInfo.id;
            _this.commentParams.type = _this.audioInfo.contentType;
            _this.wechatShare(); // 微信二次分享
            _this.statistics(); // 统计
            _this.addScore(); // 增加积分
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.audioInfo.contentCreationTime, // 创建时间
        contentId: this.audioInfo.id, // 稿件Id
        contentTitle: this.audioInfo.title,
        contentType: 11,
        memberId: this.audioInfo.editorId, // 当前稿件的编辑者的id
        nickName: this.audioInfo.editor, // 当前稿件的编辑者的用户名称
      };
      if (this.detailParams.fromFlag == 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.audioInfo.channelId, // 栏目id
          channelName: this.audioInfo.channelName, // 栏目名称
        });
      } else if (this.detailParams.fromFlag == 1) {
        tj_params = Object.assign(tj_params, {
          channelId: this.audioInfo.specialId, // 专题id
          channelName: this.audioInfo.specialName, // 专题名称
        });
      } else if (this.detailParams.fromFlag == 2) {
        tj_params = Object.assign(tj_params, {
          channelId: this.audioInfo.channelJson.id, // 自媒体id
          channelName: this.audioInfo.channelJson.name, // 自媒体名称
        });
      }
      clickPlayCount(tj_params);
      this.trackArticlePV();
    },
    /* 稿件详情页浏览埋点 */
    trackArticlePV() {
      const extra = {};
      if (this.detailParams.fromFlag == 1) {
        extra.specialName = this.audioInfo.specialName;
      }
      trackArticleDetailPg(this.audioInfo, extra);
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "gkyp", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "观看音频", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.detailParams.contentType, // 非必传，稿件的type
        contentId: this.detailParams.contentId, // 非必传，稿件的id
        contentName: this.audioInfo.title, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 显示或隐藏评论表单 */
    showCommentForm(data) {
      this.isShowCommentForm = data;
      this.commentParentId = "0";
    },
    /* 评论回复,显示评论表单 */
    showCommentReplayForm(data) {
      this.isShowCommentForm = true;
      this.commentParentId = data;
    },
    /* 滚动到评论区域或顶部 */
    isToComment(flag) {
      if (flag) {
        let top = this.$refs.comment.offsetTop;
        this.$nextTick(() => {
          this.$refs.detailBox.scrollTo({
            top: top,
            left: 0,
            behavior: "smooth",
          });
        });
      } else {
        this.$nextTick(() => {
          this.$refs.detailBox.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        });
      }
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.detailParams.contentType = Number(query.contentType) || 11;
      this.detailParams.contentId = Number(query.contentId);
      this.detailParams.fromFlag = Number(query.fromFlag) || 0;
      this.detailParams.cId = Number(query.cId) || 0;
      if (!!this.userInfo) {
        this.detailParams.memberId = this.userInfo.id;
      }
      this.detailParams.shareSign = query.shareSign;
      this.detailParams.timestamp = query.timestamp;
      this.getAudioDetail();
      loadStat(); // 友盟统计
    }
  },
};
</script>
<style scoped lang="scss">
.audio_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px 0px 40px;
  overflow-x: hidden;
  overflow-y: auto;
  .audio_box {
    width: 100%;
    height: 100%;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    .player_box {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      background-color: #000;
      overflow: hidden;
      .player_box_bg {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        filter: blur(12px) brightness(0.9);
        -webkit-filter: blur(12px) brightness(0.9);
        img {
          width: 100%;
          height: 100%;
          filter: blur(35px) brightness(0.7);
          -webkit-filter: blur(35px) brightness(0.7);
        }
      }
      video {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .detail_box {
      flex: 1;
      padding: 15px;
      overflow-x: hidden;
      overflow-y: auto;
      .detail_info {
        .title {
          line-height: 24px;
          margin-bottom: 10px;
          color: #000;
          font-size: 18px;
        }
        .detail_text {
          margin-bottom: 10px;
          color: #a1a1a1;
          font-size: 12px;
          .time {
            float: right;
          }
        }
        .detail_cont {
          overflow: hidden;
          height: auto;
          line-height: 24px;
          color: #646464;
          font-size: 16px;
          text-align: justify;
        }
      }
    }
  }
}
</style>